import React from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import { NotFound, Syllabus } from './components/pages';
import ClassesPage from './components/pages/classes/ClassesPage';
import UploadPage from './components/pages/upload/UploadPage';
import UsersPage from './components/pages/users/UploadPage';

function Routes() {
  const urlParams = new URLSearchParams(window.location.search);
  const viewAs = urlParams.get('viewAs');
  if (viewAs) {
    sessionStorage.setItem('viewAs', viewAs);
    urlParams.delete('viewAs');
    window.location.replace(
      `${window.location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`
    );
  }

  const viewAsUser = sessionStorage.getItem('viewAs');

  const userString = localStorage.getItem('syllabus-app.user');
  const user = !!userString ? JSON.parse(userString) : null;

  return (
    <RouterRoutes>
      <Route
        path="/"
        element={<ClassesPage isAdmin={user?.isAdmin} viewAs={viewAsUser} />}
      />
      <Route path="/users" element={<UsersPage isAdmin={user?.isAdmin} />} />
      <Route
        path="/upload"
        element={<UploadPage isAdmin={user?.isAdmin} viewAs={viewAsUser} />}
      />
      <Route path="/syllabus/:strm/:classnumber" element={<Syllabus />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
}

export default Routes;
